import {ConnectionStatusNotificationType, IConnectionStatus} from '../../incase-domain/connectionStatus';
import {ConnectionStatusReducerType, UPDATE_CONNECTION_STATUS} from '../actions/types/connectionStatus.action.types';

export interface ConnectionStatusReducerState {
    connectionStatus: IConnectionStatus;
}

export const preloadedState = {
    connectionStatus: {
        type: ConnectionStatusNotificationType.SUCCESS,
        message: null,
        hidden: true,
    },
};

export const connectionStatusReducer = (
    state: ConnectionStatusReducerState = preloadedState,
    action: ConnectionStatusReducerType
): ConnectionStatusReducerState => {
    switch (action.type) {
        case UPDATE_CONNECTION_STATUS:
            return {...state, connectionStatus: {...action.payload, hidden: action.payload.hidden || true}};
        default:
            return state;
    }
};
